import { DialogComponent } from '@theme/dialog';

class SavedDesignDialog extends DialogComponent {
  requiredRefs = ['dialog', 'closeButton'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('keydown', this.#handlePreviewKey, true);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.#handlePreviewKey, true);
    super.disconnectedCallback();
  }

  #handlePreviewKey = (event) => {
    if (!this.refs.dialog.open || event.isComposing) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      this.closeDialog();
    } else if (event.key === 'Tab') {
      event.preventDefault();
      event.stopPropagation();
      this.refs.closeButton.focus();
    }
  };
}

if (!customElements.get('sm-saved-design-dialog')) {
  customElements.define('sm-saved-design-dialog', SavedDesignDialog);
}
